export const education = [
  {
    degree: "Bachelor of Software Engineering",
    institution: "University of Homs — College of Information Engineering",
    year: "2019–2024",
    description: "Completed comprehensive software engineering program focusing on mobile development, backend systems, software architecture, and modern engineering practices.",
    status: "Completed"
  }
];

export const certificates = [
  {
    id: 1,
    title: "Flutter Mobile Development",
    issuer: "Internship Pakistan",
    year: "2024",
    description: "Completed advanced Flutter mobile development program covering state management, animations, performance optimization, and production-grade application development.",
    image: "https://res.cloudinary.com/debuadvrz/image/upload/v1752869029/cert_in1gpt.png",
    credential: "UC-certificate-123",
    category: "Mobile Development"
  },
  {
    id: 2,
    title: "Flutter Recommendation",
    issuer: "Darrebni Company",
    year: "2023",
    description: "Professional recommendation for Flutter development competency, demonstrating strong skills in clean architecture, state management, and collaborative project delivery.",
    image: "https://res.cloudinary.com/debuadvrz/image/upload/v1752869021/photo_2023-10-18_18-42-38_lyxfyz.jpg",
    credential: "darrebni-certificate-456",
    category: "Mobile Development"
  },
  {
    id: 3,
    title: "Flutter Training",
    issuer: "Japan Syria Friendship Association",
    year: "2022",
    description: "Intensive Flutter training program covering advanced UI development, animations, state management patterns, and mobile application best practices.",
    image: "https://res.cloudinary.com/debuadvrz/image/upload/v1752869018/photo_2023-10-18_18-42-41_mi35o9.jpg",
    credential: "jsfa-certificate-789",
    category: "Mobile Development"
  }
];